import { useRemoteBool } from '@mrkt/features/RemoteConfig';

import { RemoteProperties } from './remoteProperties';

export function useArtistFundraisingPickNewMarketsRollout() {
  return useRemoteBool(RemoteProperties.AFPNewMarkets);
}
